import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import FormLabel from "./FormLabel";
import FormHint from "./FormHint";

import "../../styles/_forms.scss";
const propTypes = {
  children: PropTypes.node,
  label: PropTypes.string,
  labelHidden: PropTypes.bool,
  type: PropTypes.oneOf([
    "textarea",
    "text",
    "email",
    "tel",
    "password",
    "number",
    "search",
    "color",
    "date",
    "time",
    "datetime-local",
  ]),
  name: PropTypes.string,
  status: PropTypes.string,
  disabled: PropTypes.bool,
  value: PropTypes.string,
  formGroup: PropTypes.string,
  hasIcon: PropTypes.string,
  size: PropTypes.string,
  placeholder: PropTypes.string,
  rows: PropTypes.number,
  hint: PropTypes.string,
};

const defaultProps = {
  children: null,
  label: "",
  labelHidden: false,
  type: "text",
  name: undefined,
  status: "",
  disabled: false,
  value: undefined,
  formGroup: null,
  hasIcon: null,
  size: "",
  placeholder: "",
  rows: 3,
  hint: null,
};

const Input = ({
  className,
  children,
  label,
  labelHidden,
  type,
  name,
  status,
  disabled,
  value,
  formGroup,
  hasIcon,
  size,
  placeholder,
  rows,
  hint,
  isError,
  selectOption = false,
  optionType,
  selectOptions=[],
  ...props
}) => {
  const wrapperClasses = classNames(
    formGroup &&
    formGroup !== "" &&
    (formGroup === "desktop" ? "form-group-desktop" : "form-group"),
    hasIcon && hasIcon !== "" && "has-icon-" + hasIcon
  );

  const classes = classNames(
    "form-input",
    size && `form-input-${size}`,
    status && `form-${status}`,
    className,
    isError && 'form-error'
  );

  const Component = type === "textarea" ? "textarea" : "input";
  /* request a demo my  */

  return (
    <>
      {label && (
        <FormLabel labelHidden={labelHidden} id={props.id} isError={isError}>
          {label}
        </FormLabel>
      )}
        { (!selectOption) ? <div className={wrapperClasses}>
        <Component
          {...props}
          type={type !== "textarea" ? type : null}
          className={classes}
          name={name}
          disabled={disabled}
          value={value}
          placeholder={placeholder}
          rows={type === "textarea" ? rows : null}
        />
        {children}
      </div> : 
              <div className={wrapperClasses}>
              <select className="selectStyling" {...props} >
                <option value="" />
                {selectOptions.map((option) => (
                  <option  value={option.value}>{option.label}</option>
                ))}
              </select>
            </div>
      }
      {hint && <FormHint status={isError ? 'error' : status} isError={isError} >{hint}</FormHint>}
    </>
  );
};

Input.propTypes = propTypes;
Input.defaultProps = defaultProps;

export default Input;
